import { LookupValue } from "../common/lookup-value";

export enum CareType {
  "Hospice" = 1,
  "Palliative",
  "Evaluation",
}

export class CareTypeLookup {
  static HOSPICE: LookupValue = new LookupValue(1, "Hospice");
  static PALLIATIVE: LookupValue = new LookupValue(2, "Palliative");
  static EVALUATION: LookupValue = new LookupValue(3, "Evaluation");
}

export function careTypeFromString(careTypeString: string) {
  switch (careTypeString.toLowerCase()) {
    case "hospice":
      return CareType.Hospice;
    case "palliative":
      return CareType.Palliative;
    case "evaluation":
      return CareType.Evaluation;
    default:
      throw new Error("Invalid careType");
  }
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/care-type.ts